import type { I18n } from '@/typings/i18n'

const it: I18n = {
  global: {
    indexTitle: 'LOOK',
    tipsTitle: 'Suggerimento',
    confirmButtonText: 'Conferma',
    cancelButtonText: 'Annulla',
    day: 'Giorno',
    people: 'Persona',
    bindButtonText: 'Legare',
    help: 'Aiuto',
    manageSubscription: 'Gestisci abbonamento',
    coupon: 'I miei Coupon',
    deleteMessage: 'Sei sicuro di voler eliminare?',
    deleteButtonText: 'Elimina',
    renameButtonText: 'Rinomina',
    downloadButtonText: 'Scarica',
    install: 'installato',
    phoneNumberLabel: 'Numero di cellulare',
    verificationCodeLabel: 'Codice di verifica',
    sendButtonText: 'Inviare',
    saveButtonText: 'Salvare',
    download: 'Scarica',
    complete: 'Completare',
    adjustButtonText: 'Regolare',
    eraser: 'Gomma',
    undo: 'Annulla',
    redo: 'Rifare',
    clear: 'Cancella',
    noDataMessage: 'Nessun dato',
    loading: 'Caricamento in corso',
    customize: 'Personalizza',
    referenceImage: 'Immagine di riferimento',
    styleImage: 'Immagine di stile',
    high: 'Alto',
    middle: 'Medio',
    low: 'Basso',
    big: 'Grande',
    small: 'Piccolo',
    select: 'Seleziona',
    upload: 'Carica',
    colon: ':',
    uploadDesc: "Clicca o trascina i file in quest'area per caricarli",
    generate: 'Generare',
    preview: 'Anteprima',
    magic: 'Intelligente',
    add: 'Aggiungi',
    subtract: 'Riduci',
    brush: 'Pennello',
    part: 'Parte',
    commonlyUsed: 'Comune',
    recommend: 'Raccomandare',
    termsOfService: 'Termini di servizio',
    userAgreement: "Accordo con l'utente",
    privacyStatement: 'Informativa sulla privacy',
    wechat: 'WeChat',
    xiaohongshu: 'Xiaohongshu',
    downloadClient: 'Scarica il client',
    ok: "D'accordo",
    and: ' e ',
    language: 'Lingua',
    copy: 'Copiare',
    copyLink: 'Copia link',
    signupTitle: 'Registrati',
    signupTitleSuffix: 'LOOK AI Strumento di design di moda in tempo reale',
    recentsTitle: 'Generato di recente - LOOK',
    projectNameTitle: '{projectName} - LOOK',
    nextStep: 'Passo successivo',
    accept: 'Accetta',
    reject: 'Rifiuta',
    about: 'A proposito',
    close: 'Chiudi',
    skip: 'Salta',
    iKnow: 'Capisco'
  },
  system: {
    updateTip: 'La nuova versione è stata scaricata. Clicca per aggiornare.',
    updateMessage: "Sei sicuro di voler chiudere l'applicazione e installare l'aggiornamento?",
    drawingDownMessage: ' richiede il download del client.',
    bonjourInstallTitle: 'Bonjour non installato',
    bonjourInstallMessage1:
      'Il servizio di ricezione della proiezione dello schermo non è installato, ',
    bonjourInstallMessage2:
      ' la funzione non può funzionare correttamente. Si prega di scaricare e installare bonjour, quindi riavviare LOOK.',
    bonjourInstallMessage3: 'Se il download non funziona ancora, clicca su "Non disponibile".',
    bonjourUnavailableTitle: 'Bonjour non installato',
    bonjourUnavailableMessage1:
      'Il servizio di ricezione della proiezione dello schermo non è installato, ',
    bonjourUnavailableMessage2: "Si prega di seguire il video guidato per forzare l'installazione",
    bonjourUnavailableMessage3:
      'Si prega di reinstallare il servizio di ricezione della proiezione dello schermo, quindi riavviare LOOK.',
    bonjourUnavailableMessage4:
      'Se cela non fonctionne toujours pas après le téléchargement, veuillez visiter notre Discord:',
    bonjourStartTitle: 'Bonjour non avviato correttamente',
    bonjourStartMessage1:
      'Il servizio di ricezione della proiezione dello schermo non è avviato correttamente, la funzione di design in tempo reale non può funzionare correttamente. Si prega di seguire le istruzioni del guida per avviare.',
    bonjourStartMessage2: 'quindi',
    bonjourStartMessage3: 'riavviare LOOK',
    bonjourStartMessage4: '1、Apri le impostazioni del sistema, cerca "servizi"',
    bonjourStartMessage5: '2、Clicca con il tasto destro su Bonjour in servizi e seleziona "Avvia"',
    bonjourStartMessage6: '3、Riavvia LOOK per usarlo',
    bonjourStartMessage7: 'Se ancora non funziona dopo il riavvio, visita il nostro Discord:',
    bonjourStartText: 'avviato correttamente',
    bonjourUnavailable: 'la funzione non può funzionare correttamente',
    bonjourDownload: 'Scarica Bonjour',
    revoUninstaller: 'Revo Uninstaller',
    forceUninstallMessage:
      "Attenzione: Se hai installato il servizio di ricezione della proiezione dello schermo, ma ricevi ancora ripetutamente avvisi che il servizio non è installato, potrebbe essere perché l'installazione non è andata a buon fine. Puoi provare a utilizzare uno strumento di disinstallazione potente per disinstallare entrambe le applicazioni Bonjour e Bonjour SDK, quindi provare a reinstallare il servizio di ricezione della proiezione dello schermo.",
    guideButtonText: 'Tutorial',
    noImageMessage: 'Nessuna immagine selezionata',
    aboutUsTitle: 'Chi siamo',
    weChatPublicAccountTitle: 'Account ufficiale WeChat',
    error400: 'Parametri della richiesta non corretti',
    error403: 'Accesso negato',
    error404: 'Indirizzo della richiesta non trovato',
    error408: 'Richiesta scaduta',
    error500: 'Errore interno del server',
    error501: 'Server non implementato',
    error502: 'Errore del gateway',
    error503: 'Servizio non disponibile',
    error504: 'Timeout del gateway',
    copySuccess: 'Copia riuscita',
    copyError: 'Copia fallita：',
    browserTips:
      'Per una migliore esperienza utente, si prega di utilizzare il browser Chrome per accedere o ',
    serviceStopMessage:
      'La tua sottoscrizione Pro è scaduta il {date}. Se non paghi entro la scadenza, il servizio verrà interrotto.',
    renewalReminderMessage: 'Se hai bisogno di continuare a usarlo, per favore',
    paymentLink: 'clicca per completare il pagamento',
    updateTipsMessage:
      "LOOK ha rilevato una nuova versione e si chiuderà automaticamente per installare l'aggiornamento.",
    osVersionNotSupportedMessageWindows:
      'Le versioni del sistema operativo inferiori a Windows 10 a 64 bit non sono supportate, il che potrebbe influire sulla tua esperienza utente. Si consiglia di aggiornare il sistema operativo o di accedere tramite un browser.',
    osVersionNotSupportedMessageMacOS:
      'Le versioni del sistema operativo inferiori a Mac OS 13 non sono supportate, il che potrebbe influire sulla tua esperienza utente. Si consiglia di aggiornare il sistema operativo o di accedere tramite un browser.',
    updatedDownloadMessage:
      "LOOK ha rilevato una nuova versione e si chiuderà automaticamente per installare l'aggiornamento.",
    receiverConnectErrorMessage:
      'Errore di connessione del ricevitore di proiezione dello schermo:{message}',
    receiverStartErrorMessage:
      'Errore di avvio del ricevitore di proiezione dello schermo:{message}',
    macOSVersionErrorMessage:
      'Errore di avvio del ricevitore di proiezione dello schermo: la versione di Mac OS è troppo bassa, si prega di aggiornare il sistema operativo.',
    airplayRTPErrorMessage:
      'Si è verificato un errore di rete durante lo streaming AirPlay. Controlla la connessione di rete e prova a riavviare LOOK.',
    networkDisconnectedMessage:
      'Connessione di rete persa, proiezione dello schermo interrotta. Si prega di controllare la connessione di rete.',
    networkReconnectedMessage:
      'La rete è stata ricollegata. Per continuare lo streaming, riavvia LOOK e ricollega il dispositivo.',
    slogan1: 'Strumento di design di moda in tempo reale con IA',
    slogan2: 'Presenta le tue idee in tempo reale!',
    slogan3: 'Design in tempo reale, risultati reali',
    slogan4: 'Trasforma immediatamente gli schizzi in rendering, genera più varianti',
    slogan5: "Fusione di stili: Supera i confini dell'immaginazione",
    slogan6: "Regolazioni parziali: Controllo preciso con l'IA",
    networkErrorMessage:
      'La rete non è attualmente connessa. Si prega di controllare le impostazioni di rete del dispositivo.',
    serverErrorMessage: 'La connessione al server è fallita. Si prega di riprovare più tardi.',
    languageChangeMessage:
      'Il passaggio a questa lingua richiede un nuovo accesso. Sei sicuro di voler cambiare?',
    downloadAppMessage:
      'Scarica e accedi all\'app per la prima volta per ottenere un <br/><span style="font-weight: 700; font-size: 24px">EXTRA 1-DAY Free trial</span>',
    downloadButtonTextMac: 'Scarica per macOS',
    downloadButtonTextWindows: 'Scarica per Windows',
    consentTitle: 'Avviso sui Cookie',
    consentTips:
      'Per fornire un servizio migliore e un\'esperienza personalizzata, utilizziamo cookie e tecnologie simili per analizzare le prestazioni del sito web, mostrare annunci personalizzati e fornire funzionalità dei social media. Facendo clic su "Accetta tutti i cookie" o continuando a utilizzare questo sito web, acconsenti all\'uso di cookie analitici e di tracciamento che ci permettono di fornire un\'esperienza più personalizzata. Consulta la nostra <span style="font-weight: 700; text-decoration: underline; cursor: pointer">Informativa sui Cookie</span> per saperne di più sui cookie che utilizziamo.',
    aboutTitle: 'Applicazione desktop LOOK',
    currentVersion: 'Versione',
    newVersion: 'Nuova Versione',
    copyright: 'Copyright © 2024 LOOK AI LIMITED',
    checkUpdateButtonText: 'Controlla aggiornamenti',
    updateButtonText: 'Aggiorna a {version}',
    noUpdateMessage: 'Hai la versione più recente',
    updateFailMessage: 'Aggiornamento fallito, LOOK tenterà di aggiornare di nuovo dopo il riavvio',
    appDownloadGuideTitle: 'Scarica il client LOOK per computer',
    appDownloadGuideSubTitle:
      'Questa funzionalità richiede il download del client LOOK per computer.',
    realtimeDesignGuideTitle: 'Guida al Real-Time Design',
    realtimeDesignGuideSubTitle1:
      'La funzione Real-Time Design richiede il download del <img style="vertical-align: text-bottom" src="{image1}" width="16" height="16" /> client LOOK per computer e il suo utilizzo sincronizzato con l\'app <img style="vertical-align: text-bottom" src="{image2}" width="16" height="16" /> Procreate.',
    realtimeDesignGuideSubTitle2:
      'Apri <img style="vertical-align: text-bottom" src="{image1}" width="16" height="16" /> Procreate e il <img style="vertical-align: text-bottom" src="{image2}" width="16" height="16" /> client LOOK per computer, quindi segui la guida per stabilire la connessione di proiezione dello schermo.',
    freeCountLimitDialogTitle: 'Limite di generazione raggiunto?',
    freeCountLimitDialogDesc:
      'Scarica e accedi all\'app per la prima volta per ottenere un <br/><span style="font-weight: 600; font-size: 24px">EXTRA 1 GIORNO di prova gratuita</span>',
    freeCountLimitDialogDescMobile:
      'Scarica e accedi all\'app per la prima volta su<br/><span style="font-weight: 600">PC o macOS</span> per un <br/><span style="font-weight: 600;font-size: 24px">EXTRA 1 GIORNO di prova gratuita</span>',
    imageSizeTooLarge: "La dimensione dell'immagine non può essere maggiore di {size}MB"
  },
  error: {
    invitationCodeUsed: 'Il codice di invito è già stato utilizzato',
    invitationCodeInvalid: 'Il codice di invito non è valido',
    networkErrorTitle: 'Errore di rete',
    networkErrorMessage:
      'Impossibile connettersi al server. Controlla la tua connessione di rete e riprova',
    retryButtonText: 'Riprova',
    upscaleScaleError:
      'Il ridimensionamento non è consentito. Per sbloccare una qualità di immagine più alta, aggiorna il tuo abbonamento.',
    campaignSystemError: 'Errore del sistema, per favore riprova più tardi',
    campaignUserAuthError: "Impossibile ottenere l'identità dell'utente",
    campaignParamError: 'Errore dei parametri',
    campaignQueryError: 'Errore di query',
    campaignNotCompleted: 'Attività non completata',
    campaignRewardAlreadyClaimed: 'Rapina già reclamata',
    campaignCouponNotAvailable: 'Buono non disponibile',
    campaignUseCoupon: 'Impossibile utilizzare il buono',
    campaignAssignCoupon: 'Impossibile assegnare il buono',
    userGoogleAuthFail: 'Accesso Google fallito',
    userNotSupportLoginType: 'Tipo di accesso non supportato',
    userSystemError: 'Errore di sistema',
    userLoginError: 'Accesso fallito'
  },
  account: {
    logoutMessage: 'Sei sicuro di voler uscire?',
    logoutButtonText: 'Disconnetti',
    bindPhoneTitle: 'Associa telefono cellulare',
    bindPhoneSuccessMessage: 'Associazione del telefono cellulare riuscita',
    bindPhoneTips: 'Associa il tuo numero di telefono per ottenere un abbonamento gratuito',
    bindPhoneEmptyNumberMessage: 'Si prega di inserire il numero di cellulare',
    bindPhoneErrorNumberMessage: 'Non è un numero di cellulare valido',
    bindPhoneVerificationCodeEmptyMessage: 'Si prega di inserire il codice di verifica',
    getInvitationCodeErrorMessage: 'Recupero delle informazioni sul codice di invito non riuscito',
    trialDuration: 'Prova gratuita: ',
    headerGiftText: 'Ottieni coupon',
    headerOneDayGiftText: "Sconto del {discount}% sull'abbonamento",
    headerSubscribeGiftText: 'Abbonati subito',
    invitePopoverTitle: 'Invita amici',
    invitePopoverDescTips:
      'I nuovi utenti che associano il loro telefono cellulare sono considerati come un invito riuscito di un nuovo utente',
    invitePopoverMark: 'Richiedi&nbsp;<span>15 $US</span>&nbsp;di buono!',
    invitePopoverDesc:
      "Per ogni amico che inviti, riceverai un buono da 15 $US che può essere utilizzato per l'abbonamento/rinnovo! Il tuo amico riceverà una prova gratuita di 15 giorni!",
    invitePopoverCodeShareTitle: 'Scansiona per Condividere',
    invitePopoverCodeCopyTitle: 'Clicca per Copiare',
    invitePopoverShareCountText: 'Inviti Rimanenti:',
    invitePopoverSubText:
      "Il numero di codici di invito è automaticamente assegnato dal sistema in base all'uso.",
    invitePopoverGiftDaysText: 'Buoni accumulati:',
    invitePopoverBindPhoneMaskText:
      'Associa il tuo telefono cellulare per attivarlo e ricevere slot di invito',
    phoneNumber: 'Numero di telefono:',
    noMemberText: 'Free',
    memberExpireAtFormat: 'DD/MM/YYYY',
    memberExpireAt: 'Data di scadenza:',
    memberUpgradeMainText: 'Sblocca limiti di generazione più elevati per immagini 4K',
    memberUpgradeMainTextFirst: 'Ottieni il 50% di sconto!',
    memberUpgradeSubText: 'Realizza la libertà di design in tempo reale!',
    memberUpgradeLinkTextActivate: 'ATTIVA',
    memberUpgradeLinkTextUpgrade: 'AGGIORNA',
    memberUpgradeLinkTextGet: 'OTTENERE',
    memberUpgradeLinkTextManage: 'GESTIRE',
    discordLoginTitle: 'Inizia con LOOK',
    discordLoginButtonText: 'Continua con Discord',
    discordLoginSubText1: 'Iscrivendoti, crei un account LOOK AI e accetti i ',
    discordLoginSubText2: ' di LOOK AI.',
    googleLoginButtonText: 'Continua con Google',
    invitePageTitle: 'Ciao, designer',
    invitePageNicknamePlaceholder: 'Soprannome',
    invitePageInvitationCodePlaceholder: 'Codice di invito',
    invitePageSubmitButtonText: 'Inizia a usare',
    invitePageTips: '<span style="font-weight: 700">8 GIORNI GRATIS</span> con codice invito',
    invitePageInvitationCodeInvalid: 'Codice di invito non valido',
    hasInvitationCodeText: 'Ho un codice di invito',
    shareInvitationCodeText: `Strumento di Design di Moda in Tempo Reale LOOK AI

💻 Accesso PC: https://app.lookfashion.ai
📱 Attualmente non supportato su dispositivi mobili

Codice di invito: {code}`,
    limitedTitle: 'Rallenta…',
    limitedSubject:
      'Hai raggiunto il limite di generazione per <span style="font-weight: 600">{name}</span>,',
    limitedTime: 'Puoi continuare a usare il servizio dopo {time}.',
    limitedRealtimeDesignTime:
      'Si prega di continuare a utilizzare nel prossimo ciclo di abbonamento.',
    upgradeTitle: 'Stanco di aspettare?',
    upgradeSubject:
      'Aggiorna l\'abbonamento per <span style="font-weight: 600">generare immediatamente</span>!',
    upgradeButtonText: 'Aggiorna ora',
    mergeAccount: 'Sei tu?',
    mergeAccountDesc: 'Sì, associa il tuo account',
    mergeAccountCancel: 'No, torna al login',
    recentLoginText: 'Ultimo'
  },
  project: {
    recentListTitle: 'Generato di recente',
    collectListTitle: 'Lista dei preferiti',
    projectListTitle: 'Elenco dei Progetti',
    emptyMessage1: 'Nessun progetto creato ancora',
    emptyMessage2: 'Clicca qui sotto per creare un progetto',
    emptyMessage3: 'Inizia a generare',
    emptyMessage4: 'Nessuna immagine salvata ancora, genera e ',
    emptyMessage5: 'salva per aggiungere immagini',
    emptyMessage6: 'Crea prima un nuovo progetto, quindi genera nel progetto e ',
    emptyMessage7: 'salva LOOK',
    createProjectButtonText: 'Nuovo progetto',
    projectNamePlaceholder: 'Si prega di inserire il nome del progetto',
    projectEnterText1: 'Entra nel progetto',
    projectEnterText2: "Entra nell'area di lavoro",
    createProjectTip: 'Si prega di creare prima un progetto'
  },
  image: {
    text2ImageTitle: 'Testo-a-Immagine',
    originalityTitle: 'Schizzo-a-Immagine',
    styleExtensionTitle: 'Estensione Stile',
    styleFuseTitle: 'Fusione Stili',
    tuneTitle: 'Regolazione Area',
    recolorTitle: 'Ricolorazione Intelligente',
    backgroundTitle: 'Cambiamento di Scena AI',
    eraserTitle: 'Cancellazione magica',
    cutoutTitle: 'Ritaglio con un Clic',
    flowerPatternExpansionTitle: 'Motivo a Piastrelle Senza Giunte',
    aiExpansionTitle: 'Espansione AI',
    hdTitle: 'Miglioramento Risoluzione',
    drawingTitle: 'Real-Time Design',
    patternTitle: 'Cartografia dei Motivi',
    imageCount: '',
    generateButtonText: 'Genera LOOK',
    generateButtonSubscribeBoxTitle1: '50% di sconto per i nuovi abbonati',
    generateButtonSubscribeBoxTitle2: 'Sblocca la versione pro',
    generateButtonSubscribeBoxDesc1:
      'Prova gratuita scaduta? Sblocca subito più privilegi di generazione con uno sconto!',
    generateButtonSubscribeBoxDesc2:
      'Passa alla versione Pro per realizzare la libertà di Real-Time Design!',
    generateButtonSubscribeBoxButtonText1: 'Prova gratuita',
    generateButtonSubscribeBoxButtonText2: 'Passa alla versione Pro',
    originalSizeText: 'Rapporto',
    uploadImageButtonText: 'Carica immagine',
    uploadPatternButtonText: 'Carica motivo',
    editMaskButtonText: 'Modifica maschera',
    removeMaskButtonText: 'Elimina maschera',
    imageUploaderDesc:
      '<span style="color: #4c4c4c; font-size: 14px">Clicca o trascina per caricare</span><br/> <span style="color: #b0b2ae; font-size: 12px">(Le immagini nell\'area di salvataggio qui sotto e a destra possono essere trascinate direttamente)</span>',
    generatePreviewText: 'Genera anteprima({count}/{max})',
    previewListHelpMessage1:
      "Le immagini generate sono temporaneamente memorizzate in questo elenco, fino a {max} immagini. Quando supera {max} immagini, l'immagine generata per prima sarà eliminata.",
    previewListHelpMessage2:
      "Le immagini temporanee devono essere salvate nell'album per essere conservate permanentemente e per eseguire ulteriori azioni.",
    clearPreviewButtonText: 'Cancella tutte le anteprime',
    segmentErrorMessage: "L'analisi semantica dell'immagine non è riuscita, si prega di riprovare",
    generatingMessage: "Generazione dell'immagine in corso",
    previewWaitingMessage: "Elaborazione dell'immagine, attendere prego",
    previewFailedMessage: "Elaborazione dell'immagine non riuscita, impossibile visualizzare",
    imageInQueueMessage: 'In coda',
    imageNotVerifyMessage: 'Violazione',
    saveImageButtonText: "Salva nell'album",
    deleteTmpImageButtonText: 'Elimina immagini temporanee',
    previewImageInfoText: "Informazioni sull'immagine",
    promptDefaultPlaceholder:
      "Inserisci una descrizione del design o delle parole di descrizione per migliorare l'accuratezza della generazione",
    promptDefaultPlaceholder2: 'Inserisci una descrizione del motivo',
    promptDefaultPlaceholder3: "Inserisci una descrizione dell'immagine",
    promptDefaultPlaceholder4: 'Inserisci una descrizione del modello',
    removeBgErrorMessage: 'Rimozione dello sfondo non riuscita',
    removeBgButtonText: 'Rimuovi sfondo',
    removeBgLoadingMessage: 'Rimozione dello sfondo in corso, attendere prego',
    cropTip1:
      "Cerca di lasciare abbastanza spazio nella parte superiore e inferiore dell'immagine per generare la testa e le gambe del modello",
    cropTip2: "Se l'immagine caricata è troppo piccola, ritagliala a una dimensione appropriata",
    diyModelText: 'Modello personalizzato',
    commonModelText: 'Modello pubblico',
    exclusiveModelText: 'Modello esclusivo',
    promptTitle: 'Caratteristiche del design',
    promptTitle2: 'Descrizione del motivo',
    promptTitle3: "Descrizione dell'immagine",
    promptTitle4: 'Descrizione del modello',
    promptInputTitle: 'Caratteristiche del design (selezione multipla)',
    selectModelTitle: 'Selezione del modello',
    referenceStrengthLabel: 'Intensità di riferimento',
    modelSettingTitle: 'Impostazioni modello',
    advancedSettingsTitle: 'Impostazioni avanzate',
    negativePromptTitle: 'Prompt negativo',
    negativePromptPlaceholder:
      "Inserisci o seleziona gli elementi che non vuoi vedere nell'immagine",
    generateCountTitle: 'Dimensione del Lotto',
    cleanerTitle: 'Rimuovi il primo piano',
    maskSwitchViewButtonText: 'Cambia visuale',
    regenerateButtonText: 'Rigenera',
    imageLoadingMessage: "Caricamento dell'immagine in corso",
    maskGenerateFailedMessage: 'Creazione della maschera non riuscita',
    maskPreviewDialogConfirmButtonText1: 'Conferma il ritaglio',
    maskPreviewDialogConfirmButtonText2: 'Creare una maschera',
    maskPreviewDialogCancelButtonText: 'Continua a modificare',
    objectRemovalDialogCancelButtonText: 'Continua a modificare',
    objectRemovalFailedMessage: 'Rimozione del primo piano non riuscita',
    magicMaskGenerateFailedMessage: 'Creazione della maschera intelligente non riuscita',
    partMaskDialogTitle: 'Selezione parziale',
    imageAnalyzingMessage: "Analisi dell'immagine in corso",
    cutout: 'Ritaglio',
    maskDialogConfirmButtonText1: "Preparazione dell'anteprima in corso",
    maskDialogConfirmButtonText2: 'Genera anteprima',
    maskDialogConfirmTip: 'Bloccato? Riprova!',
    rangeOfChangeLabel: 'Livello di regolazione',
    lesser: 'Variazione piccola',
    more: 'Variazione grande',
    disableModelDesc:
      'Disabilita il modello, assicurati che non ci sia alcun modello nello schizzo',
    generateFailedMessage: "Creazione dell'attività di generazione delle immagini non riuscita",
    taskNotEnoughTip:
      'È stato raggiunto il numero massimo di attività di generazione simultanea. Si prega di riprovare più tardi.',
    saveTip1:
      "Salvare {saveType} significa che, dopo aver salvato l'immagine, l'operazione di miglioramento della chiarezza verrà eseguita automaticamente.",
    saveTip2:
      "Se il numero totale di attività LOOK e {saveType} in corso ha raggiunto il numero massimo di attività simultanee, l'operazione di salvataggio di {saveType} sarà temporaneamente non disponibile.",
    promptButtonText1: 'Finitura AI',
    promptButtonText2: 'Descrizione immagine',
    promptButtonMessage: 'Per favore inserisci prima un prompt',
    promptButtonFailMessage: 'Generazione fallita, per favore riprova',
    colorMatchTitle: 'Corrispondenza di colore',
    colorMatchSubject: 'Da illustrazione di moda a foto',
    colorMatchDesc: 'Presenta il colore e la texture originale del tessuto',
    patternExpansionSize: "Dimensione dell'espansione",
    patternExpansionSizeSmall: 'Piccola',
    patternExpansionSizeMedium: 'Media',
    patternExpansionSizeLarge: 'Grande',
    flowerPatternExpansionStep1: '1.Ein nicht kontinuierliches Muster hochladen',
    flowerPatternExpansionStep2: '2.Wählen Sie den Bereich aus, den Sie erweitern möchten',
    flowerPatternExpansionStep3:
      '3.LOOK erweitert die Kanten des Musters, um das ursprüngliche Muster in ein kontinuierliches Muster zu verwandeln. Es kann gespeichert oder heruntergeladen werden, um für zukünftige Entwürfe zu verwenden.',
    maskCreateText: 'Crea maschera'
  },
  cleaner: {
    maskDialogTitle: "Seleziona l'area da cancellare",
    maskDesc: "Seleziona l'area da cancellare"
  },
  drawing: {
    generatingMessage: 'Generazione in corso, attendere prego',
    startDrawingMessage: 'Si prega di iniziare a disegnare',
    waitingScreenMessage: 'In attesa della proiezione dello schermo...',
    canvasCropperGuideMessage:
      'Si prega di ritagliare lo schermo sulla dimensione del canvas su LOOK',
    startDrawingButtonText: 'Inizia a progettare',
    stopDrawingButtonText: 'Clicca per fermare',
    videoNotSupportMessage: 'Il browser corrente non supporta la riproduzione video',
    canvasGuideMessage1:
      'Avvia <img src="{image}" width="26" height="26" /> Procreate e disattiva/riattiva <span style="font-weight: 700; text-decoration: underline">Canvas Broadcasting</span>',
    canvasGuideMessage2:
      'Canvas Broadcasting deve essere disattivato e riattivato per funzionare correttamente',
    castScreenGuideMessage1: 'La versione attuale supporta solo',
    castScreenGuideMessage2: ' Procreate proiezione dello schermo',
    castScreenGuideMessage2After: '',
    castScreenGuideMessage3:
      "Segui la guida per aprire la connessione di mirroring dello schermo dell'iPad {placeholder}",
    castScreenGuideMessage4: '(Entrambi i dispositivi devono essere sulla stessa rete)',
    screenPreviewTitle: 'Anteprima proiezione',
    reCropButtonText: 'Ritaglia nuovamente'
  },
  hd: {
    scaleTitle: "Migliora la qualità dell'immagine",
    imageClaritySD: 'Salvare',
    imageClarityHD: 'Salvare in HD',
    imageClarityUHD: 'Salvare in UHD',
    imageClarityTextSD: 'SD',
    imageClarityTextHD: 'HD',
    imageClarityTextUHD: 'Ultra HD',
    generatingMessage: ' Miglioramento in corso'
  },
  matte: {
    maskDialogTitle: "Seleziona l'area da mantenere",
    maskDesc: "Seleziona l'area da mantenere",
    magicLabel: 'Ritaglio intelligente'
  },
  originality: {
    lineDrawingTitle: 'Schizzo',
    lineDrawingUploadTitle: 'Caricamento schizzo',
    sampleClothesTitle: 'Abito campione'
  },
  recolor: {
    maskDialogTitle: "Seleziona l'area da cambiare colore",
    maskDesc: "Seleziona l'area da cambiare colore",
    colorSelectTitle: 'Selezione dei colori',
    getColorWarningMessage: 'Il browser corrente non supporta la funzione contagocce'
  },
  styleFusion: {
    referenceImageDialogTitle1: 'Schizzo di stile'
  },
  background: {
    maskDialogTitle: "Seleziona l'area da mantenere",
    maskDesc: "Seleziona l'area da mantenere",
    backgroundDialogTitle: 'Aggiungi sfondo',
    backgroundDescTitle: 'Descrizione dello sfondo',
    promptInputPlaceholder:
      'Inserisci una descrizione dello sfondo per migliorare la precisione della generazione',
    referenceBackgroundTitle: 'Sfondo di riferimento',
    intelligentFillLightLabel: 'Illuminazione intelligente',
    backgroundGenerateTimeoutMessage: 'Timeout nella generazione dello sfondo, riprova',
    backgroundGenerateFailedMessage: 'Generazione dello sfondo non riuscita, riprova',
    addBackgroundTitle: 'Aggiungi sfondo',
    backgroundSizeTitle: 'Dimensione dello sfondo',
    effectPreviewMessage: "Anteprima dell'effetto",
    canvasEmptyMessage: 'Si prega di aggiungere prima uno sfondo'
  },
  text2Image: {
    textExampleMessage1:
      "Una foto di lookbook di una modella italiana che indossa un maglione oversize in maglia, con un primo piano della persona. L'abito è un maglione a quadri realizzato con filati di diversi colori, che rappresenta l'abbigliamento outdoor e streetwear di un marchio di moda. Fotografato nello stile di Campbell Addy, è uno scatto editoriale di alta moda.",
    textExampleMessage2:
      "Una modella cinese alla moda che indossa un lungo abito fluente in stile cinese moderno. L'abito presenta colori a bassa saturazione e stampe coordinate. È un look da passerella della Shanghai Fashion Week che mostra un moderno senso della moda.",
    textExampleMessage3:
      "Un primo piano di una modella di moda, che indossa un abito con divisioni strutturali, abbigliamento moderno, semplice, pulito e fluido. L'abito è un mix di tessuti in seta e lino, perfetto per la copertina di una rivista di moda.",
    textExampleMessage4:
      "Una modella alla moda indossa una camicia bianca con ricami squisiti. La camicia presenta ampi motivi floreali rosso scuro e dettagli in ricamo dorato, aggiungendo un tocco di eleganza vintage. La modella indossa un paio di orecchini rotondi in oro, con capelli ordinatamente acconciati all'indietro, rivelando il suo viso. Lo sfondo verde scuro mette in risalto la carnagione e l'abbigliamento della modella, dando all'immagine complessiva un forte senso artistico. La foto ha toni morbidi e bassa saturazione, creando un'atmosfera serena e poetica.",
    textExampleMessage5:
      "Una modella di moda in solitaria, indossa un maglione arancione brillante oversize in tessuto a maglia pesante, con un design a collo alto e maniche leggermente larghe. La parte inferiore è una gonna di pelle blu scuro a linea A, con una finitura lucida e una texture rigida. La modella indossa scarpe con tacco alto e suola spessa, aggiungendo una sensazione di pesantezza. L'outfit è completato da occhiali da sole con montatura arancione e lenti blu, conferendo all'insieme un aspetto futuristico e drammatico. I colori sono ad alta saturazione con forti contrasti, creando un effetto visivo audace e marcato. Gli accessori e il trucco sono unici ed esagerati, enfatizzando la personalizzazione e l'arte. Lo sfondo è semplice.",
    textExampleMessage6:
      'Una giovane donna alla moda che indossa una giacca fluorescente gialla, in piedi per strada in Giappone, cielo blu, luce naturale, foto a mezzo busto',
    textExampleMessage7:
      "Una modella bianca ed elegante indossa un lungo cappotto minimalista grigio scuro con scollo a V e stivali Martin, fotografata nello stile di Theo Angelopoulos. Il cappotto è realizzato in tessuto di cashmere del marchio Lemaire, con pieghe e un'aletta anteriore sovrapposta, emanando un'atmosfera serena e sacra. La scena è ambientata in una foresta nebbiosa.",
    textExampleMessage8:
      "Una donna alla moda che indossa un audace maglione verde lavorato a maglia con uno sfondo viola. Il maglione presenta un design unico con elementi bianchi e blu, che assomigliano a volti astratti. Il tessuto sembra essere una maglia spessa, probabilmente lana o una miscela di lana, comunemente usata in questo tipo di indumenti per calore e texture. La vestibilità è ampia, con maniche che si estendono oltre i polsi, casual e oversize. Il verde vibrante domina l'aspetto generale, contrastando con i pantaloni neri per creare una combinazione di colori accattivante. Lo stile complessivo è avant-garde e rientra nella moda di strada contemporanea.",
    textExampleMessage9:
      "Un'influencer di moda coreana indossa una camicia di jeans azzurro chiaro larga con maniche ampie. La camicia sembra essere stata trattata per sembrare consumata, con diversi strappi e aree scolorite, indicando uno stile vintage. La modella indossa anche pantaloncini di colore chiaro, probabilmente in denim, abbinati alla camicia. Ha lunghi capelli neri lisci, un'espressione neutra e guarda dritto davanti a sé. Lo sfondo è grigio chiaro, mettendo in risalto l'outfit. Testura da pellicola.",
    textExampleMessage10:
      "Una modella coreana si trova davanti a uno sfondo minimalista. Indossa un cardigan a maglia oversize verde oliva chiaro con cappuccio, che sembra molto confortevole e casual. Il cardigan è realizzato in tessuto a maglia spessa e presenta un motivo geometrico tridimensionale. La vestibilità è ampia, adatta per l'autunno o l'inverno. La modella indossa anche un berretto da baseball marrone scuro, con il logo sul cappello chiaramente visibile. La sua espressione è neutra e lo sguardo è rivolto di lato, dando un'atmosfera rilassata e disinvolta. Lo stile generale è orientato verso il casual e il fashion, enfatizzando il comfort e la modernità. La foto ha una texture simile a quella di un film.",
    textExampleMessage11:
      "Una modella si trova davanti a uno sfondo neutro. Indossa un abito unico color avorio con maniche larghe e un design con orlo asimmetrico, caratterizzato da più strati di tessuto sovrapposti in uno stile che ricorda l'abbigliamento tradizionale cinese. Il tessuto è morbido e fluido, con una certa consistenza, probabilmente realizzato in cotone leggero o misto seta. La vestibilità è ampia, offrendo un look moderno, sia confortevole che elegante. L'abito è principalmente color avorio, con pantaloni neri che offrono un contrasto. Lo stile generale è orientato al minimalismo con un tocco di eleganza. La modella ha un aspetto ordinato, con un'acconciatura semplice e un'espressione calma, aggiungendo un'impressione di serenità e fiducia al look complessivo.",
    generationRatioTitle: "Rapporto d'immagine",
    tryText: 'Provalo',
    freeProportionText: 'libero'
  },
  tune: {
    maskDialogTitle: "Seleziona l'area da modificare",
    maskDesc: "Seleziona l'area da modificare",
    promptTitle: 'Prompt'
  },
  pattern: {
    maskDialogTitle: "Seleziona l'area da modificare",
    maskDesc: "Seleziona l'area da modificare",
    assistImagesTitle: 'Pattes'
  },
  modelTryOn: {
    modelImageDialogTitle1: 'Carica modello',
    modelImageDialogTitle2: 'Carica abbigliamento',
    maskDesc: 'Seleziona l\'area da modificare',
    maskDialogTitle: 'Seleziona l\'area da modificare',
    upperBodyTitle: 'Haut/Vêtement',
    dressTitle: 'Bas/Vêtement',
    loadingText: 'Selezione intelligente in corso, attendere prego...',
    errorText: 'Selezione intelligente fallita, per favore riprova',
    upperBodyMaskDialogTitle: 'Seleziona l\'area del corpo superiore/vestito',
    dressMaskDialogTitle: 'Seleziona l\'area del corpo inferiore/vestito',
    singleMaskDialogTitle: 'Seleziona l\'area del modello',
    single: 'Singolo capo',
    multi: 'Multi capi',
    singleTitle: 'Singolo capo'
  },
  modelFace: {
    uploadImageTitle: 'Carica immagine originale',
    maskDialogTitle: 'Seleziona l\'area da modificare',
    maskDesc: 'Seleziona l\'area da modificare',
    selectModelTitle: 'Seleziona modello',
    modelSelectorDesc: '<span style="color: #4c4c4c; font-size: 14px">Clicca per selezionare il modello</span>',
    headSize: 'Dimensione della testa'
  },
  diyModel: {
    sex: 'Sesso',
    male: 'Maschio',
    female: 'Femmina',
    age: 'Età',
    kid: '5',
    juvenile: '15',
    adult: '25',
    youth: '35',
    middleAged: '50',
    elderly: '60',
    color: 'Colore della pelle',
    bodyShape: 'Corporatura',
    hair: 'Capelli',
    length: 'Lunghezza',
    hairstyle: 'Acconciatura',
    slenderBody: 'Corpo snello',
    hourglassBody: 'Corpo equilibrato',
    muscularBody: 'Muscoloso',
    babyFatBody: 'Paffuto',
    shortAndFatBody: 'Basso e grasso',
    curvaceousBody: 'Corpo curvy',
    straight: 'Capelli lisci',
    wavy: 'Capelli ondulati',
    curly: 'Capelli ricci',
    braided: 'Capelli intrecciati',
    naturallyCurly: 'Capelli naturalmente ricci',
    updo: 'Capelli raccolti',
    airBangs: 'Frangia leggera',
    dreadlocks: 'Treccine',
    ponytail: 'Coda di cavallo',
    bald: 'Testa rasata',
    centerPartedHair: 'Capelli con riga centrale',
    bangs: 'Frangia dritta',
    frontBangs: 'Ciocca frontale',
    short: 'Capelli corti',
    long: 'Capelli lunghi',
    shoulderLength: 'Capelli a media lunghezza',
    extraLongHair: 'Capelli molto lunghi',
    pixieCut: 'Capelli corti alle orecchie',
    collarboneLengthHair: 'Capelli alle spalle',
    shoulderLengthHair: 'Capelli sopra le spalle',
    waistLengthHair: 'Capelli alla vita',
    fairSkinWhite: 'Carnagione chiara',
    darkSkin: 'Carnagione scura',
    yellowSkin: 'Carnagione gialla',
    asian: 'Asiatico',
    european: 'Europeo',
    african: 'Africano',
    american: 'Americano',
    middleEastern: 'Middle-eastern'
  },
  maskDialogHelpTip: {
    mask: "Fare clic con il mouse per selezionare l'area da mantenere",
    matte:
      "Carica un'immagine, fai clic con il mouse per selezionare l'area da mantenere. Se non è necessario alcun ritaglio, fare clic direttamente sul pulsante di conferma.",
    cutout: "Fare clic con il mouse per selezionare l'area da mantenere",
    part: "Fare clic con il mouse per selezionare l'area da utilizzare come maschera",
    objectRemoval:
      'Per rimuovere parte del primo piano, fai clic su "Rimuovi primo piano", quindi fai clic con il mouse sull\'area da rimuovere. Se non è necessario, fare clic direttamente sul pulsante "Conferma".'
  },
  subscribe: {
    subscribeTitle:
      'Offerta speciale primo abbonamento&nbsp;<span style="font-size: 32px; font-weight: 500; line-height: 44.8px">SCONTO DEL {discount}%</span>&nbsp;',
    subscribeTitleFree:
      'Il primo abbonamento ti offre&nbsp;<span style="font-size: 32px; font-weight: 500; line-height: 44.8px">7 giorni di abbonamento gratuito</span>',
    person: 'Persona',
    month: 'Mese',
    year: 'Anno',
    currency: '$US',
    mostPopularText: 'Popolare',
    noMemberText: 'Nessun abbonamento',
    subscribeSubText:
      'Si rinnova automaticamente alla scadenza dell\'abbonamento, <span style="color: #0d0d0d">torna al prezzo regolare il mese successivo</span>, può essere annullato in qualsiasi momento',
    subscribeSubTextFree:
      'Gli abbonamenti possono essere annullati in qualsiasi momento senza costi aggiuntivi',
    priceNegotiableText: 'Corporatura',
    tryThisText: 'Il più popolare',
    payButtonText1: 'Abbonarsi',
    payButtonText1Free: '0.00$US Ottieni 7 giorni di abbonamento gratuito!',
    payButtonText2: 'Abbonarsi',
    payButtonText3: 'Aggiorna piano',
    payButtonText4: 'Abbonamento attuale',
    payButtonText5: 'Servizio clienti',
    payButtonText6: 'Modifica abbo',
    payButtonText7: 'Abbonarsi',
    payMessage1: ' è il piano dopo la fine della prova gratuita',
    payMessage2: 'Attivazione in corso',
    payMessage3: 'Pagamento dopo la fine della prova di 15 giorni',
    payMessage4: 'Pagare',
    payMessage5: 'Si prega di scansionare il codice QR per completare il pagamento',
    payMessage6:
      'Rinnovo automatico a {currency}{amount}/mese alla scadenza, annullabile in qualsiasi momento',
    payMessage7:
      'Alla scadenza della prova, rinnovo automatico a {currency}{amount}/mese, annullabile in qualsiasi momento',
    payMessage8: 'Si prega di scansionare il codice QR per completare la firma',
    paySuccessText: 'Abbonamento riuscito',
    paySubText: "L'attivazione implica l'accordo",
    freeMemberSuccessDesc:
      "Le spese verranno detratte dopo la fine della prova di abbonamento di 15 giorni. L'abbonamento può essere annullato in qualsiasi momento senza costi aggiuntivi.",
    receiveAwardTitle: '🎉Benvenuto su LOOK',
    receiveAwardTitleTaskGuide: '🎉Prova gratuita di 1 giorno ricevuta!',
    receiveAwardSubject:
      'Abbiamo preparato per te una<br><span style="font-size: 24px; font-weight: 700">{number} giorni di prova gratuita</span>',
    receiveAwardSubjectTaskGuide:
      'Prova facilmente le funzionalità principali di LOOK',
    receiveAwardTip: 'Troppo poco?',
    receiveAwardButtonTextTaskGuide: 'Inizia la prova',
    receiveAwardButtonText: 'Prova gratuita di {number} giorni per {currency}0,00',
    memberInvitedOnly: 'Solo su invito',
    memberTipsStarter: "Perfetto per designer individuali e neofiti dell'IA.",
    memberTipsPlus: 'Per designer esperti che necessitano di strumenti AI avanzati.',
    memberTipsPro: "Per professionisti in cerca di piena potenza dell'IA.",
    memberFreeDesc1Label: 'Immagini generate',
    memberFreeDesc1Value: '8 immagini/giorno',
    memberFreeDesc2Label: 'Risoluzione',
    memberFreeDesc2Value: 'Standard',
    memberFreeDesc3Label: 'Attività simultanee',
    memberFreeDesc3Value: '2',
    memberFreeDesc4Label: 'Real-Time Design',
    memberFreeDesc4Value: 'No',
    memberDescStarter0Label: 'Generazioni',
    memberDescStarter0Value: 'Illimitato',
    memberDescStarter1Label: 'Velocità di generazione',
    memberDescStarter1Value: 'Normale',
    memberDescStarter2Label: 'Generazioni simultanee',
    memberDescStarter2Value: '{count}',
    memberDescStarter3Label: 'Frequenza di generazione',
    memberDescStarter3Value: '50 / 4 h',
    memberDescStarter4Label: 'Frequenza di upscaling',
    memberDescStarter4Value: '8 / 4 h',
    memberDescStarter5Label: "Migliora la qualità dell'immagine",
    memberDescStarter5Value: '2K',
    memberDescStarter6Label: 'Real-Time Design',
    memberDescStarter6Value: '1200 min / mo.',
    memberDescPlus0Label: 'Generazioni',
    memberDescPlus0Value: 'Illimitato',
    memberDescPlus1Label: 'Velocità di generazione',
    memberDescPlus1Value: 'Veloce',
    memberDescPlus2Label: 'Generazioni simultanee',
    memberDescPlus2Value: '{count}',
    memberDescPlus3Label: 'Frequenza di generazione',
    memberDescPlus3Value: '150 / 4 h',
    memberDescPlus4Label: 'Frequenza di upscaling',
    memberDescPlus4Value: '16 / 4 h',
    memberDescPlus5Label: "Migliora la qualità dell'immagine",
    memberDescPlus5Value: '3K',
    memberDescPlus6Label: 'Real-Time Design',
    memberDescPlus6Value: '3600 min / mo.',
    memberDescPro0Label: 'Generazioni',
    memberDescPro0Value: 'Illimitato',
    memberDescPro1Label: 'Velocità di generazione',
    memberDescPro1Value: 'Turbo',
    memberDescPro2Label: 'Generazioni simultanee',
    memberDescPro2Value: '{count}',
    memberDescPro3Label: 'Frequenza di generazione',
    memberDescPro3Value: 'Illimitato',
    memberDescPro4Label: 'Frequenza di upscaling',
    memberDescPro4Value: '48 / 4 h',
    memberDescPro5Label: "Migliora la qualità dell'immagine",
    memberDescPro5Value: '4K',
    memberDescPro6Label: 'Real-Time Design',
    memberDescPro6Value: 'Illimitato',
    stripeConfirmMessage1: 'Elaborazione ordine',
    stripeConfirmMessage2: "Si prega di confermare se l'abbonamento è riuscito.",
    stripeConfirmMessage3:
      'Per verificare che la tua carta sia valida, effettueremo una pre-autorizzazione di 1 {currency}.',
    stripeConfirmMessage4:
      'Questo è solo per verifica e <span style="font-weight: 600; color: #0d0d0d">non comporterà alcun addebito effettivo</span>, quindi stai tranquillo.',
    stripeSuccessMessage: 'Ordine completato!',
    stripeFailedMessage: 'Verifica fallita, riprova o cambia metodo di pagamento.',
    stripeConfirmButtonText: 'Abbonamento completato',
    stripeCancelButtonText: 'Annullare',
    stripeEditBillingMessage: "L'abbonamento di fatturazione viene modificato...",
    stripeEditBillingConfirmButtonText: 'Completare',
    stripeUpgradeMessage: "Sei sicuro di voler aggiornare l'abbonamento?",
    stripeUpgradeSuccessMessage: 'Aggiornamento riuscito!',
    stripeSubscribeRenewButtonText: 'Riprendi Abo',
    stripeSubscribeRenewConfirmMessage: 'Sei sicuro di voler riprendere il rinnovo?',
    stripeSubscribeRenewSuccessMessage: 'Abbonamento ripreso',
    stripeSubscribeCancelButtonText: 'Disdici',
    stripeSubscribeCancelConfirmMessage: 'Sei sicuro di voler annullare il rinnovo?',
    stripeSubscribeCancelSuccessMessage: 'Abbonamento annullato',
    cancelQuestionaireTitle:
      "Seleziona il motivo per l'annullamento dell'abbonamento (scelta singola)",
    cancelQuestionaireSubject:
      'Per favore, scegliete una delle seguenti opzioni (scelta unica) per aiutarci a capire il motivo della vostra cancellazione.',
    cancelQuestionaireSelection1: "Voglio semplicemente annullare l'abbonamento",
    cancelQuestionaireSelection2: 'Il prezzo è troppo alto',
    cancelQuestionaireSelection3: 'Il contenuto del servizio non soddisfa più le mie esigenze',
    cancelQuestionaireSelection4: 'Esperienza utente scadente',
    cancelQuestionaireSelection5: 'Problemi tecnici (es. errori frequenti o interruzioni)',
    cancelQuestionaireSelection6: "Ho trovato un'alternativa migliore",
    cancelQuestionaireSelection7: 'Altro (si prega di specificare)',
    cancelQuestionaireSelection8: 'I migliori',
    cancelQuestionaireSubmiteButtonText: 'Invia',
    cancelQuestionaireCancelButtonText: "Lo userò ancora un po'",
    cancelSuccessMainTitle: 'Il tuo abbonamento è stato annullato',
    cancelSuccessSubject: "Riceverai presto un'email di conferma",
    reactivateTitle: 'Non intendevi annullare?',
    reactivateSubject: 'Nessun problema, ti riattiviamo subito!',
    reactivateButtonText: 'Riattiva ora',
    upgradeTitle: 'Piano di aggiornamento',
    upgradeSubject: "Il tuo aggiornamento dell'abbonamento avrà effetto immediato.",
    upgradeDesc:
      'Il costo sarà ripartito in base ai giorni rimanenti del mese corrente e detratto dalla tariffa del nuovo piano.',
    qrcodeTimeout: 'Codice QR scaduto',
    clickToRefresh: 'Clicca per riprovare',
    cycleText: 'Fatturato mensile',
    yearlyText: 'Fatturato annuale',
    paymentTypeMonthlyText: 'Mensile',
    paymentTypeYearlyText: 'Annuale',
    freeUsageText: 'Reste di generazione gratuita oggi: {count}',
    currentSubscription: 'Abbonamento attuale',
    expiredText: 'Rinnovo: {date}'
  },
  similer: {
    similerTitle: 'Ricerca visiva',
    similerWaitingMessage: 'Componente inizializzazione, attendere',
    similerSearchFailedMessage: 'Ricerca fallita, clicca per riprovare',
    similerNoSimilarMessage: 'Nessuna immagine simile trovata',
    similerLoadingMoreDetailImageError:
      'Immagine in alta risoluzione non caricata, clicca per riprovare'
  },
  taskType: {
    generate: "Generazione d'immagine",
    upscale: 'Upscale',
    realtimeDesign: 'Real-Time Design'
  },
  rewardTask: {
    rewardTaskListTitle1: 'Ottieni 8 giorni di prova gratuita',
    rewardTaskListTitle1Intl: 'Prova le funzioni principali',
    rewardTaskListDesc1: 'Collega il telefono',
    rewardTaskListGuide1: 'Collega il telefono',
    rewardTaskListDesc2: 'Crea progetto',
    rewardTaskListGuide2: 'Crea progetto',
    rewardTaskListDesc3: 'Schizzo-a-Immagine',
    rewardTaskListGuide3:
      'Clicca o trascina per caricare immagini per trasformare schizzi, disegni stilistici, illustrazioni di moda e foto reali in effetti realistici.',
    rewardTaskListDesc4: 'Schizzo-a-Immagine (Corrispondenza di colore)',
    rewardTaskListGuide4:
      'In Schizzo-a-Immagine, attivando <span style="color: #4c4c4c; font-weight: 600; text-decoration-line: underline">Ripristino colore</span> <img src="{img}" style="vertical-align: middle;" /> verranno utilizzati i colori originali. Se disattivato, i colori verranno generati casualmente.',
    rewardTaskListDesc5: 'Estensione stile',
    rewardTaskListGuide5:
      "Nell'Estensione stile, l'IA può creare rapidamente una serie di variazioni basate sulle tue immagini di abbigliamento caricate.",
    rewardTaskListDesc6: 'Fusione stili',
    rewardTaskListGuide6:
      'La Fusione stili richiede il caricamento di due immagini per unire capi di abbigliamento con materiali di ispirazione, creando una fusione di diversi stili di moda.',
    rewardTaskListDesc7: 'Testo-a-Immagine',
    rewardTaskListGuide7:
      'Inserisci una descrizione del tuo design per generare un LOOK. Puoi utilizzare <img src="{img}" style="vertical-align: middle; width: 13px; height: 13px;" /> AI Polish e Descrizione immagine per aiutarti a scrivere le descrizioni.',
    getRewardButtonText1: 'Terminé',
    sketchToImageInitPrompt:
      'Una bellissima modella indossa un abito asimmetrico con spalle scoperte con una gonna ampia con grandi pieghe e onde, e un tessuto lucido. Abbinato a un paio di tacchi alti a punta scuri, questo abito emana eleganza e modernità, con un tessuto lucido leggermente metallico.',
    sketchToImageColorInitPrompt:
      "Foto di moda della modella che indossa un outfit elegante composto da una lunga gonna in lino grigio argento, un maglione dolcevita nero e un gilet a quadri giallo caldo. L'outfit include stivali con suola spessa e una cintura a quadri giallo caldo e nera con un grande fiocco. Il gilet e la gonna sono decorati con motivi geometrici. I suoi capelli sono pettinati alti sulla fronte e indossa occhiali da sole. Foto a figura intera.",
    styleExtensionInitPrompt:
      "Un capo d'alta moda che presenta un blazer strutturato e corto con revers appuntiti e dettagli asimmetrici delle tasche, su sfondo bianco. Il blazer è abbinato a una gonna drappeggiata a vita alta che mostra pannelli sovrapposti e orli fluenti e asimmetrici. Il design enfatizza una silhouette avant-garde con un mix di precisione sartoriale e drappeggio fluido. Il materiale sembra essere un tessuto leggero e opaco, come cotone o una miscela di cotone, che conferisce un aspetto morbido ma strutturato. Il colore verde terra attenuato esalta l'estetica minimalista e contemporanea. Il design complessivo riflette un equilibrio tra sartoria moderna e fluidità artistica, perfetto per la moda da passerella o editoriale. fotografia di prodotto, texture dettagliate.",
    styleFusionInitPrompt:
      'Un maglione colorato a maglia grossa con un motivo a fiocco tridimensionale lavorato a maglia sul petto, su sfondo bianco.',
    text2ImageInitPrompt:
      "Una modella dalla pelle nera che indossa un blazer oversize e una gonna in pelle, gambe lunghe in stivali con un fiocco gigante sul retro dei tacchi, in posa per una fotografia di moda Vogue su sfondo bianco. L'immagine è iperrealistica.",
    limitTime: 'Limitiert  ',
    guideStartButtonText: 'Genera',
    confirmCloseDialogTitle: 'Salta tutorial',
    confirmCloseDialogDesc:
      'Sei sicuro di voler saltare il tutorial? Non potrai più vederlo in seguito.',
    confirmCloseDialogCancelButtonText: 'Annulla',
    confirmCloseDialogConfirmButtonText: 'Sì, salta',
    rewardTitle: 'Il tuo boost di design attende!',
    rewardDescription: 'Utilizza il tuo coupon e scopri le nuove funzionalità di design potenti ora.',
    couponType1: 'Sconto',
    couponType2: 'Pagamento',
    expiredText: 'Valido fino a: ',
    useNow: 'Utilizza ora!'
  },
  contextMenu: {
    copy: 'Copia',
    paste: 'Incolla',
    selectAll: 'Seleziona tutto'
  },
  login: {
    success: 'Ciao, Designer!',
    closeWindow: "Hai effettuato l'accesso con successo. Puoi chiudere questa finestra ora."
  },
  update: {
    updateDialogTitle: 'Aggiornamento',
    updateDialogMessage: 'È disponibile una nuova versione. Vuoi aggiornare?',
    updateDialogCurrentVersion: 'Versione corrente',
    updateDialogNewVersion: 'Nuova versione',
    updateDialogCancelButtonText: 'Non ora',
    updateDialogUpdateButtonText: 'Aggiorna',
    updateDialogUpdateButtonLoadingText: 'Sto aggiornando...'
  },
  updateError: {
    updateErrorDialogTitle: 'Aggiornamento',
    updateErrorDialogMessage: 'È disponibile una nuova versione. Vuoi aggiornare?',
    updateErrorDialogButtonText: 'Aggiorna'
  },
  updateProgress: {
    updateProgressDialogTitle: 'Sto aggiornando...'
  },
  remainingBalance: {
    realTimeDesign: 'Ore di design in tempo reale',
    minute: 'minuti',
    hour: 'ore',
    frequency: 'Frequenza',
    upscale: 'Upscale',
    last: 'Ultimo',
    image: 'Immagine',
    unlimited: 'Illimitato'
  },
  compositor: {
    opacity: 'Opacità',
    saturation: 'Saturazione',
    brightness: 'Luminosità',
    contrast: 'Contrasto',
    hue: 'Tonalità',
    depthMapFailed: 'Generazione della mappa di profondità fallita, riprova'
  },
  coupon: {
    couponListTitle: 'I miei coupon',
    couponExpireCountdown: 'Tempo rimanente: ',
    couponExpire: 'Valido fino a: ',
    couponListEmpty: 'Nessun coupon disponibile',
    couponListEmptyDescription1: 'Unisciti al nostro canale Discord ufficiale',
    couponListEmptyDescription2: 'Partecipa a eventi per ottenere grandi regali!',
    couponListEmptyButton: 'Unisciti a Discord'
  },
  plugins: {
    pluginsTitle: 'Boutique de plugin',
    addPluginButtonText: 'PIN',
    removePluginButtonText: 'UNPIN',
    addedPluginButtonText: 'PINNED',
    noImages: 'Nessuna immagine del plugin',
    noPluginComponentText:
      'Nessuna pagina del plugin trovata, controlla se il plugin è configurato correttamente',
    editPluginsButtonText: 'Modifica plugin',
    editPluginsCompletedButtonText: 'Modifica completata',
    morePluginsButtonText: 'Più plugins',
    removePluginTipsTitle: 'Rimuovi plugin',
    removePluginTips1: 'Il plugin può essere aggiunto di nuovo da',
    removePluginTips2: '<span style="color: #0d0d0d; font-weight: 600;">Boutique de plugins</span>',
    pluginDisabled: 'Plugin non disponibile',
    pluginsTips: {
      title: 'LOOK AI',
      subtitle: 'Boutique de plugin disponibile!',
      plugintipTitle1: 'Strumenti Tutto-in-Uno:',
      plugintipDesc1:
        'Saluta il nostro nuovo Mercato dei Plugin! Abbiamo raccolto tutte le tue funzionalità preferite—Ricolorazione Intelligente, Cambiamento di Scena AI, Cancellazione Magica, Ritaglio con un Clic e altro ancora—in un unico posto pratico. Basta pinarli e torneranno in azione!',
      plugintipTitle2: 'Personalizza il Tuo Spazio di Lavoro:',
      plugintipDesc2:
        "Vai al Mercato dei Plugin > Aggiungi Plugin > Clicca su 'Modifica Plugin' nella barra degli strumenti a sinistra, quindi trascina e organizza le icone come preferisci! Il tuo LOOK, le tue regole!",
      plugintipTitle3: 'Altri Plugin in Arrivo!',
      plugintipDesc3:
        "Hai delle idee? Dicci quali nuovi strumenti vorresti o condividi il tuo feedback. LOOK è costruito per te e siamo tutt'orecchi!"
    },
    pluginsTipsFooter: {
      discord: 'Unisciti alla nostra comunità Discord',
      instagram: 'Vedi di più su Instagram',
      email: 'Invia un email: {email}'
    }
  }
}

export default it as any
